import { Link } from 'react-router-dom';

const footerLinks = {
  shop: [
    { to: '/category/dresses', label: '连衣裙' },
    { to: '/category/tops', label: '上衣' },
    { to: '/category/pants', label: '裤装' },
    { to: '/category/skirts', label: '半身裙' },
    { to: '/category/outerwear', label: '外套' },
    { to: '/category/accessories', label: '配饰' },
  ],
  inspiration: [
    { to: '/articles', label: '穿搭灵感' },
    { to: '/article/autumn-2026-trends', label: '秋季趋势' },
    { to: '/article/capsule-wardrobe-guide', label: '极简衣橱' },
    { to: '/article/office-style-guide', label: '职场穿搭' },
  ],
  about: [
    { to: '/about', label: '关于我们' },
    { to: '/about', label: '品牌故事' },
    { to: '/about', label: '联系我们' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-2">
              <Link to="/" className="font-heading text-xl font-semibold text-background-50 whitespace-nowrap cursor-pointer">
                蘑菇网
              </Link>
              <p className="mt-3 text-sm text-secondary-300 leading-relaxed max-w-xs">
                蘑菇网是专注时尚女装的购物平台，汇聚海量潮流穿搭、新款女装、美妆配饰，让每位女性轻松找到心仪单品。
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-bookmark-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">热门分类</h4>
              <ul className="flex flex-col gap-2">
                {footerLinks.shop.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">穿搭灵感</h4>
              <ul className="flex flex-col gap-2">
                {footerLinks.inspiration.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">关于我们</h4>
              <ul className="flex flex-col gap-2">
                {footerLinks.about.map((link) => (
                  <li key={link.to + link.label}>
                    <Link to={link.to} className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-secondary-400">
              &copy; 2026 蘑菇网 MoguWang.com 版权所有 | 沪ICP备2024XXXXXXXX号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-secondary-400 hover:text-background-50 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-secondary-400 hover:text-background-50 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-secondary-400 hover:text-background-50 transition-colors cursor-pointer">退换政策</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}